import { navigation_geo_select_geo, navigation_load_menu } from '../reducers/navigationSlice';
import { template_load } from '../reducers/templateSlice';

export const customMiddleware = store => next => action => {
   const state = store.getState();

   if (action.type === 'function') {
      next(action);
   }

   // Navigation
   else if (action.type === 'get/collectiontemplate/fulfilled') {
      const state = store.getState();
      if (state.collection.type && state.collection.type.toLowerCase() !== 'benchmarks') {
         store.dispatch(navigation_load_menu(action.payload.GeographyId));
         store.dispatch(navigation_geo_select_geo(action.payload.Geography));
      }
      next(action);
   }

   // Note: This was in the Dashboard but it seems redundant and not needed
   // else if (action.type === `collection/loadCollection/fulfilled`) {
   //     const state = store.getState();
   //     if (action.payload.Type.toLowerCase() !== 'benchmarks') {
   //         if (state.template.geographyId && state.template.geography) {
   //             store.dispatch(navigation_load_menu(state.template.geographyId));
   //             store.dispatch(navigation_geo_select_geo(state.template.geography));
   //         }
   //     }
   //     return next(action);
   // }

   // else if(action.type === 'collection/loadCollection/fulfilled' || action.type === 'collection/setSelectedTemplate') {
   //     const collection = store.getState().collection;
   //     store.dispatch(template_load({collectionId: collection.id, id: collection.selectedTemplateId, roleBenchmarks: false}))
   //     next(action);
   // }
   else {
      next(action);
   }
};

/*

- For running after a thunk function runs if(action.type === [Thunk Function] + /fulfilled 
- For State: const state = store.getState()
- For Dispatching: store.dispatch([Import reducer function and use])

*/
